'use client';

import React, { useContext, useId } from 'react';
import { RadioGroupContext } from './RadioGroup';

interface RadioProps {
  value?: string | number;
  checked?: boolean;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function Radio({
  value,
  checked,
  disabled,
  className,
  children,
  onChange,
}: RadioProps) {
  const id = useId();
  const group = useContext(RadioGroupContext);

  const isChecked = group ? group.value === value : checked;
  const isDisabled = disabled ?? group?.disabled;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    if (value != null) group?.onChange?.(value);
  };

  const classes = ['ui-radio', isChecked && 'checked', isDisabled && 'disabled', className]
    .filter(Boolean)
    .join(' ');

  return (
    <label htmlFor={id} className={classes}>
      <input
        id={id}
        type="radio"
        value={value}
        checked={isChecked}
        disabled={isDisabled}
        name={group?.name}
        onChange={handleChange}
      />
      <span className="dot" />
      {children}
    </label>
  );
}
